export type OperationsLocale = "ru" | "kk";

const messages = {
  kk: {
    brandSubtitle: "Сервисті басқару",
    checking: "Платформа тексерілуде",
    dashboard: "Шолу",
    description:
      "Бірыңғай дизайн тілі, локализация және қолдау коды бар күй моделі екі мобильді қолданбада да жұмыс істейді.",
    eyebrow: "Итерация 2",
    health: "Платформа күйі",
    navQuality: "Сапа",
    navSafety: "Қауіпсіздік",
    navService: "Сервис",
    ready: "Платформа дайын",
    reference: "Қолдау коды",
    title: "Операциялық интерфейс бірыңғай жүйеге қосылды",
    unavailable: "Платформа уақытша қолжетімсіз",
  },
  ru: {
    brandSubtitle: "Управление сервисом",
    checking: "Проверяем платформу",
    dashboard: "Обзор",
    description:
      "Единый визуальный язык, локализация и модель состояний с кодом поддержки теперь работают в обоих мобильных приложениях.",
    eyebrow: "Итерация 2",
    health: "Состояние платформы",
    navQuality: "Качество",
    navSafety: "Безопасность",
    navService: "Сервис",
    ready: "Платформа готова",
    reference: "Код для поддержки",
    title: "Операционный интерфейс подключён к общей системе",
    unavailable: "Платформа временно недоступна",
  },
} as const;

export type OperationsMessage = keyof (typeof messages)["ru"];

export function operationsText(locale: OperationsLocale, key: OperationsMessage): string {
  return messages[locale][key];
}
